"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareSpecificity = exports.calcSpecificity = exports.splitCompoundSelectors = exports.groupCompoundSelectors = exports.walk = exports.stringifySelectorAst = exports.parseCssSelector = void 0;
var selector_parser_1 = require("./selector-parser");
Object.defineProperty(exports, "parseCssSelector", { enumerable: true, get: function () { return selector_parser_1.parseCssSelector; } });
__exportStar(require("./ast-types"), exports);
var stringify_1 = require("./stringify");
Object.defineProperty(exports, "stringifySelectorAst", { enumerable: true, get: function () { return stringify_1.stringifySelectorAst; } });
var walk_1 = require("./ast-tools/walk");
Object.defineProperty(exports, "walk", { enumerable: true, get: function () { return walk_1.walk; } });
var compound_1 = require("./ast-tools/compound");
Object.defineProperty(exports, "groupCompoundSelectors", { enumerable: true, get: function () { return compound_1.groupCompoundSelectors; } });
Object.defineProperty(exports, "splitCompoundSelectors", { enumerable: true, get: function () { return compound_1.splitCompoundSelectors; } });
var specificity_1 = require("./ast-tools/specificity");
Object.defineProperty(exports, "calcSpecificity", { enumerable: true, get: function () { return specificity_1.calcSpecificity; } });
Object.defineProperty(exports, "compareSpecificity", { enumerable: true, get: function () { return specificity_1.compareSpecificity; } });
//# sourceMappingURL=index.js.map